import ABCyaLib from '@abcya/abcya_lib';
import ABCyaPhaser from '@abcya/abcya_phaser';

export function SavePrintCake(Action,scene)
{
    scene.playSound('flame_counter');
    if (Action.Action === "Save")
    {
        doSave(scene.game, ()=>{scene.BackFromPrintSave()});
    }
    else if(Action.Action === "Print")
    {
        doPrint(scene.game, ()=>{scene.BackFromPrintSave()});
    }
}

export function doPrint(game, callback) {
    const { canPrintImages, canSaveImages } = ABCyaLib.Environment.instance.capabilities;

    if(canSaveImages) {
        // Print and rotate portion of screen
        game.renderer.snapshotArea(170, 0, 684, 768, async (image)=>{
            // Mobile doesn't currently print, so it routes print requests to camera roll saves. 
            // In this case we don't want to rotate the image.
            if(canPrintImages) {
                try{
                    let printStatus = await ABCyaLib.PrintSave.instance.printImage(image);
                    callback(printStatus);
                }
                catch(error){
                  callback(false, error);
                }
            }
            else{
                let saveStatus = await ABCyaLib.PrintSave.instance.saveImage(image, {fileName: ABCyaPhaser.Localization.instance.getLocalizedString('file_name')});
                callback(saveStatus)
            }
        });
    }
}

export function doSave(game, callback) {
    const { canSaveImages } = ABCyaLib.Environment.instance.capabilities;

    if(canSaveImages) {
        try{
            game.renderer.snapshot(async (image)=>{
                let saveStatus = await ABCyaLib.PrintSave.instance.saveImage(image, {fileName: ABCyaPhaser.Localization.instance.getLocalizedString('file_name')});
                callback(saveStatus)
            })
        }
        catch(error){
          callback(false, error);
        }
    } else {
        console.log("Cannot save on this platform")
        callback(null)
    }
}
